<template>
  <CCol sm="12" class="d-flex justify-content-between">
    <div>
      <h1 class="titlePage font-weight-normal text-capitalize">{{ $t(`${titlePage}`) }}</h1>
      <ol class="breadcrumb breadcrumbCustom mb-0" v-if="itensBreadcrumb && Boolean(pathImport)">
        <li role="presentation" v-for="(item, i) in itensBreadcrumb" :key="i" class="breadcrumb-item d-flex">
          <router-link
            :to="item.to"
            tag="a"
            target="_self"
            class="font-weight-semi-bold"
            :class="{ disabled: item.text !== 'choose methods', 'router-link-exact-active': routeName(item.text) }"
          >
            {{ $t(item.text) }}
          </router-link>
        </li>
      </ol>
    </div>

    <template v-if="false">
      <div class="d-flex flex-column" v-if="$route.name !== 'complete'">
        <div class="d-flex justify-content-end">
          <CButton @click="openModal = !openModal" class="btn-white font-sm py-3 px-5 text-gray-700">
            Cancel
          </CButton>
        </div>
        <transition name="fade" v-if="openModal">
          <div class="modalCancel modal">
            <div class="modal__body modalCancel__body p-5">
              <!-- <p class="font-weight-semi-bold mb-1">Type DELETE to confirm</p> -->
              <!-- <CInput type="text" v-model="textCofirmUser" /> -->
              <p class="text-gray-700">If you click Confirm, you will lose all the information uploaded until now</p>
              <div>
                <CButton class="btn btn-primary" @click="cancel($route.name)">
                  confirm
                </CButton>
                <CButton @click="openModal = !openModal" type="link">
                  Cancel
                </CButton>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </template>
  </CCol>
</template>

<script>
export default {
  name: 'HeaderAudience',
  props: {
    itensBreadcrumb: {
      type: Array,
      required: true,
    },
    titlePage: {
      type: String,
      required: true,
    },
    subTitlePage: {
      type: String,
    },
    showCancel: {
      type: Boolean,
    },
  },
  data() {
    return {
      openModal: false,
      textCofirmUser: null,
      pathRouter: '',
    }
  },
  methods: {
    cancel(value) {
      this.openModal = false

      if (value == 'choose-methods') {
        this.$router.push({ name: 'home' })
        return
      }

      if (value == 'organize') {
        this.$store.dispatch('audience/clearSummary')
      }

      this.$router.push({ name: 'choose-methods' })
    },
    routeName(text) {
      return this.$route.name == 'import' && text == 'import'
    },
  },
  computed: {
    confirmString() {
      return this.textCofirmUser === 'DELETE' ? false : true
    },
    pathImport() {
      return this.$route.path.split('/')[2] || this.$route.path.split('/')[1] == 'import-contact'
    },
  },
}
</script>

<style lang="scss" scope>
.breadcrumb {
  padding-left: 0;
  padding-right: 0;
  border: none;
  &-item {
    + .breadcrumb-item::before {
      content: '>';
    }

    a {
      text-decoration: none !important;
      color: var(--gray-700);

      &.router-link-exact-active {
        border-bottom: 3px solid var(--primary);
        color: var(--secondary);
      }

      &.disabled {
        pointer-events: none;
      }
    }
  }
}
</style>
